import { Button } from "react-admin";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  makeStyles,
} from "@material-ui/core";
import React, { useState } from "react";
import { useField } from "react-final-form";
import { filter } from "lodash";

const useStyles = makeStyles({
  dialog: {
    "& .MuiDialog-paper": {
      overflowY: "unset",
    },
  },
});

interface RemoveSelectedStudentButtonProps {
  studentIds: number[];
  handleResetSelectedValues: () => void;
}

const RemoveSelectedStudentButton: React.FC<
  RemoveSelectedStudentButtonProps
> = ({ studentIds, handleResetSelectedValues }) => {
  const [open, setOpen] = useState<boolean>(false);
  const [selectedStudents, setSelectedStudents] = useState<any>([]);

  const studentsField = useField("students");
  const formStudentsChangedField = useField("formStudentsChanged");

  const classes = useStyles();

  const handleOpenDialog = () => {
    const findStudents = filter(studentsField.input.value, (loc: any) =>
      studentIds.includes(loc.id),
    );
    setSelectedStudents(findStudents);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleSaveRemoveSelectedStudents = () => {
    studentsField.input.onChange(
      studentsField.input.value.filter(
        (loc: any) => !studentIds.includes(loc.id),
      ),
    );

    setSelectedStudents([]);
    formStudentsChangedField.input.onChange(true);

    handleResetSelectedValues();

    handleClose();
  };

  return (
    <>
      <Button label="Remove Selected Students" onClick={handleOpenDialog} />

      <Dialog
        open={open}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className={classes.dialog}
        maxWidth="md"
      >
        <DialogTitle id="alert-dialog-title">
          Remove Selected Students
        </DialogTitle>
        <DialogContent>
          <DialogContentText color="initial">
            Are you sure you want to remove this student?
          </DialogContentText>

          <ul style={{ fontWeight: 600, margin: 5 }}>
            {selectedStudents.map((student: any) => (
              <li key={student.id}>
                {student.firstName} {student.lastName}
              </li>
            ))}
          </ul>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="secondary" label="Back" />
          <Button
            onClick={handleSaveRemoveSelectedStudents}
            color="primary"
            label="Save"
          />
        </DialogActions>
      </Dialog>
    </>
  );
};

export default RemoveSelectedStudentButton;
